import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/recruit/__components/RecruitContent.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/recruit/recruit.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/ui-utilities.scss");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
